import * as Routes from '../js/routes.js.erb';
window.Routes = Routes;
$(document).ready(function () {
  if (window.location.href.indexOf("flash") > -1) {
    // extract all args from url
    let dt = {}; // will become eg: {token: '..', push_kind_1: 'true', push_kind_2: 'false', push_kind_3: 'true', push_kind_4: 'true'}
    let ar = window.location.search.substr(1).split('&');
    for (let keyval_pair of ar) { // eg: 'token=337b0ea7e96a0e'
      let [key, val] = keyval_pair.split('='); // eg: key='push_kind_1'
      dt[key] = val;
    }
    // now we have:
    /* dt = {
     *   flash-success: "Deine%2BE-Mail-Adresse%2Bwurde%2Berfolgreich%2Bf%25C3%25BCr%2Bdie%2BPush-Notifications%2Bbest%25C3%25A4tigt."
     *   ort: "17"
     *   token: "xxxxxxxxxxxxxxxxxxxxxxxxxxx"
     * }
     */
    let flash_    = window.location.href.split("=")[0].split("-").pop();
    let msg       = window.location.href.split("=").pop();
    let alert_msg = '';
    let alert_type= '';

    if (dt['flash-success'] != undefined) {
      alert_type = 'alert-success';
      alert_msg  = decodeURIComponent(dt['flash-success']);

    } else if (dt['flash-info'] != undefined) {
      alert_type = 'alert-info';
      alert_msg  = decodeURIComponent(dt['flash-info']);

    } else if (dt['flash-warning'] != undefined) {
      alert_type = 'alert-warning';
      alert_msg  = decodeURIComponent(dt['flash-warning']);

    } else if (dt['flash-error'] != undefined) {
      alert_type = 'alert-danger';
      alert_msg  = decodeURIComponent(dt['flash-error']);
    }

    // TODO: improve special characters-handling
    alert_msg = alert_msg.
      replace(/\+/g, " ").
      replace(/%C3%A4/g, "ä").
      replace(/%C3%B6/g, "ö").
      replace(/%C3%BC/g, "ü").
      replace(/%C3%84/g, "Ä").
      replace(/%C3%96/g, "Ö").
      replace(/%C3%9C/g, "Ü");

    showAlert(alert_msg, alert_type);
  }
});

function showAlert(alert_msg, alert_type) {
  $('#alert_placeholder').append($('#alert_placeholder').append(`<div id='alert-div' class="alert ${alert_type} alert-dismissible fade show" role="alert">${alert_msg}<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`));
  //close it in 3 secs
  setTimeout(function () {
    $("#alert-div").remove();
  }, 10000);
}
$(document).on('turbo:load', function () {
  /*
   * If the user clicked on the link inside a push-notification-email to manage
   * the push-notification settings, the view is initialized and the values are
   * inside [data-push-mail-subscriber] -> use these values, so that the user
   * can manage the settings even if he is using a different device.
   */
  // get the stuff-eg: dt = {'token': '..', 'push-kind-1': 'true', 'push-kind-2': 'false', 'push-kind-3': 'true', 'push-kind-4': 'true'}
  let dt = $("[data-push-mail-subscriber]").data('push-mail-subscriber');
  // and store it
  if (dt != undefined && dt.token && dt['push-kind-1']) {
    console.log(`perform storing...`);
    let token = dt.token;
    delete dt.token;
    let notification_types = JSON.stringify(dt);
    localStorage.setItem('email-sub-token', token);
    localStorage.setItem('notification_types', JSON.stringify(dt));
  }

  let bell_flag_ = true;
  const PUSH_KIND_IDS = ['push-kind-1', 'push-kind-2', 'push-kind-3', 'push-kind-4', 'push-kind-5'];
  const aggregatorSelector = (kind) => `input.set-btn.setting-switch[data-push-kind='${kind}']:not([data-id])`;
  const categorySelector = (kind) => `input.set-btn.setting-switch[data-push-kind='${kind}'][data-id]`;

  const readNotificationState = () => {
    try {
      return JSON.parse(localStorage.getItem('notification_types')) || {};
    } catch (_e) {
      return {};
    }
  };
  const writeNotificationState = (state) => localStorage.setItem('notification_types', JSON.stringify(state));
  const writeGarbageIds = (ids) => localStorage.setItem('garbage_push_type_ids', JSON.stringify(ids));
  const availableKinds = () => PUSH_KIND_IDS.filter((kind) => $(aggregatorSelector(kind)).length);
  const normalizeBoolean = (value) => value === true || value === 'true';

  const ensureStateDefaults = () => {
    const current = readNotificationState();
    availableKinds().forEach((kind) => {
      if (current[kind] === undefined) {
        current[kind] = false;
      } else {
        current[kind] = normalizeBoolean(current[kind]);
      }
    });
    writeNotificationState(current);
    return current;
  };

  const setAggregatorChecked = (kind, checked) => $(aggregatorSelector(kind)).prop('checked', checked);
  const setCategoryChecked = (kind, checked) => $(categorySelector(kind)).prop('checked', checked);

  const syncGarbageIdsWithDom = () => {
    const ids = $(categorySelector('push-kind-3'))
      .map((_, el) => $(el).prop('checked') ? $(el).data('id') : null)
      .get()
      .filter((id) => id !== undefined && id !== null);
    writeGarbageIds(ids);
  };

  const syncStateToDom = () => {
    const state = ensureStateDefaults();
    availableKinds().forEach((kind) => {
      setAggregatorChecked(kind, state[kind]);
    });
    checkAll();
    return state;
  };

  const anyAggregatorsChecked = (state) => availableKinds().some((kind) => state[kind]);

  const setAllKinds = (checked) => {
    const state = ensureStateDefaults();
    availableKinds().forEach((kind) => {
      setAggregatorChecked(kind, checked);
      if (kind === 'push-kind-3') {
        setCategoryChecked(kind, checked);
      }
      state[kind] = checked;
    });
    writeNotificationState(state);
    syncGarbageIdsWithDom();
    checkAll();
    return state;
  };

  const readEmailToken = () => localStorage.getItem('email-sub-token');

  const notificationState = syncStateToDom();
  bell_flag_ = !anyAggregatorsChecked(notificationState);

  $(document).on("click", "#allow-all-push", function () {
    const emailToken = readEmailToken();
    setAllKinds(true);
    if (emailToken) {
      change_email_subscription(emailToken);
    }
    change_push_subscription(Routes.subscribe_path(), null);
    Turbo.visit('/einstellungen', { action: 'replace' });
  });

  $("#push-kind-all").off('click').on('click', function () {
    const checked = $(this).prop('checked');
    const emailToken = readEmailToken();
    setAllKinds(checked);
    if (emailToken) {
      change_email_subscription(emailToken);
    }
    change_push_subscription(checked ? Routes.subscribe_path() : Routes.unsubscribe_path(), null);
    $("#push-sub-form").collapse(checked ? "show" : "hide");
  });

  $(document).off("click", ".set-btn").on("click", ".set-btn", function () {
    const kind = $(this).data('push-kind') || this.id;
    if (!kind) { return; }

    const isCategory = $(this).data('id') !== undefined;
    const emailToken = readEmailToken();
    const state = ensureStateDefaults();

    if (isCategory) {
      const anyCategoryChecked = $(categorySelector(kind)).toArray().some((el) => $(el).prop('checked'));
      setAggregatorChecked(kind, anyCategoryChecked);
      state[kind] = anyCategoryChecked;
    } else {
      const isChecked = $(this).prop('checked');
      setAggregatorChecked(kind, isChecked);
      if (kind === 'push-kind-3') {
        setCategoryChecked(kind, isChecked);
      }
      state[kind] = isChecked;
    }

    writeNotificationState(state);
    syncGarbageIdsWithDom();
    checkAll();

    if (!anyAggregatorsChecked(state)) {
      if (emailToken) {
        change_email_subscription(emailToken);
      }
      change_push_subscription(Routes.unsubscribe_path(), null);
      $("#push-sub-form").collapse("hide");
      return;
    }

    if (state[kind]) {
      if (emailToken) {
        change_email_subscription(emailToken);
      }
      change_push_subscription(Routes.subscribe_path(), kind);
      $("#push-sub-form").collapse("show");
    } else {
      if (emailToken) {
        change_email_subscription(emailToken);
      }
      if (kind === "push-kind-3") {
        change_push_subscription(Routes.subscribe_path(), kind);
      } else {
        change_push_subscription(Routes.unsubscribe_path(), kind);
      }
    }
  });

  $('#g-districts- li').find('i').on('click', async function() {
    change_push_subscription(Routes.unsubscribe_path(), 'push');
  });

  $(document).ready(function () {
    bell_flag_ ? $("#push-sub-form").collapse("hide") : $("#push-sub-form").collapse("show");
  });
  checkAll();
});

$(document).on('turbo:load', function () {
  // === Update sticky offset for sticky bar ===
  function updateStickyOffset() {
    const navbarHeight = $('.navbar').outerHeight() || 0;
    $('.sticky-top-custom').css('top', navbarHeight + 'px');
  }

  updateStickyOffset();
  $(window).on('resize', updateStickyOffset);

  // === Scroll with navbar + sticky bar offset ===
  function scrollToFirstFuture($container) {
    const $el = $container.find(".future-holiday").first();
    if ($el.length) {
      const navbarHeight = $('.navbar:visible').outerHeight() || 0;
      const stickyBarHeight = $('.sticky-top-custom:visible').outerHeight() || 0;
      const totalOffset = navbarHeight + stickyBarHeight + 200; // +10px margin

      const offset = $el.offset().top - totalOffset;

      $('html, body').animate({ scrollTop: offset });

      // Optional: highlight effect
      // $el.addClass("highlight-future");
      // setTimeout(() => $el.removeClass("highlight-future"), 2000);
    }
  }

  // On initial page load
  const $activePane = $(".tab-pane.active");
  if ($activePane.length) {
    scrollToFirstFuture($activePane);
  }

  // On Bootstrap tab change
  $(document).on("shown.bs.tab", 'a[data-bs-toggle="tab"]', function (e) {
    const targetId = $(e.target).attr("href"); // e.g. "#school" or "#public"
    const $pane = $(targetId);
    if ($pane.length) {
      scrollToFirstFuture($pane);
    }
  });
});


function checkAll() {
  const kinds = ['push-kind-1', 'push-kind-2', 'push-kind-3', 'push-kind-4', 'push-kind-5'].filter((kind) => $(`input.set-btn.setting-switch[data-push-kind='${kind}']:not([data-id])`).length);
  if (!kinds.length) {
    $("#push-kind-all").prop('checked', false);
    return;
  }
  const allChecked = kinds.every((kind) => $(`input.set-btn.setting-switch[data-push-kind='${kind}']:not([data-id])`).toArray().every((el) => $(el).prop('checked')));
  $("#push-kind-all").prop('checked', allChecked);
}

async function change_push_subscription(url, kind) {
  let garbage_push_type_ids = localStorage.getItem('garbage_push_type_ids');
  navigator.serviceWorker && navigator.serviceWorker.ready.then(registration => {
    registration.pushManager.getSubscription()
      .then(subscription => {
        if (subscription) {
          window.Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
              let formData = new FormData();
              formData.append('ort_id', JSON.parse(localStorage.getItem('main_city'))['id']);
              if (kind) {
                formData.append('push_kind', kind);
                if(kind === 'push-kind-3' && garbage_push_type_ids){
                  formData.append('garbage_type_ids', garbage_push_type_ids)
                }
              }
              formData.append('subscription', JSON.stringify(subscription));
              return fetch(url, {
                method: 'post',
                headers: {
                  "X-CSRF-Token": document.querySelectorAll('meta[name="csrf-token"]')[0]["content"],
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData
              });
            }
          });
        }
      })
      .catch(function (err) {
        console.log('Error during getSubscription()', err);
      });
  });
}
async function change_email_subscription(email_token) {
  let formData = new FormData();
  let url_ = '/email-subscription';
  let types_array_ = localStorage.getItem('notification_types');
  formData.append('push_kinds', types_array_)
  formData.append('token', email_token)
  const response = await fetch(`${url_}`, {
    method: 'post',
    headers: {
      "X-CSRF-Token": document.querySelectorAll('meta[name="csrf-token"]')[0]["content"],
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData
  })
  console.log(response.json())
}
